import { useParams } from "next/navigation";
import {
  CallToActionBasePageURL,
  CallToActionSelectType,
} from "@/constants/call-to-action";
import { useClientConfig } from "@/context/clientConfig";
import { useTranslation } from "@/i18n/client";
import { createLocalizedSitePathURL } from "@/utils/url/createLocalizedSitePathURL";
import type { SiteBuilderCallToAction } from "@/types/call-to-action";

export function useGetLinkAttrsByCallToActionConfig(
  ctaConfig: SiteBuilderCallToAction = {} as SiteBuilderCallToAction,
) {
  const { sitePath } = useParams<{ sitePath: string }>();
  const {
    siteConfig: { locale, primaryLocale },
  } = useClientConfig();
  const { t } = useTranslation("site-builder");
  const { selectType, shown } = ctaConfig;

  let url = "";
  let label = "";

  if (selectType === CallToActionSelectType.BasePage) {
    const { type, baseCustomText } = ctaConfig;

    url = createLocalizedSitePathURL(
      sitePath,
      locale,
      primaryLocale,
      CallToActionBasePageURL[type],
    );
    label = baseCustomText || t(`site-builder.cta.pages.${type}.label`);
  }

  if (selectType === CallToActionSelectType.LandingPage) {
    const { customUrl, customText } = ctaConfig;

    url = createLocalizedSitePathURL(
      sitePath,
      locale,
      primaryLocale,
      customUrl,
    );
    label = customText;
  }

  if (selectType === CallToActionSelectType.Custom) {
    const { customUrl, customText } = ctaConfig;

    url = customUrl;
    label = customText;
  }

  const {
    openInNewTabEnabled,
    size,
    colorStyle: color,
    variant,
    captionText,
    captionPosition,
    enabled,
  } = ctaConfig;

  return {
    url,
    label,
    openInNewTab: openInNewTabEnabled,
    shown: shown && enabled && selectType !== CallToActionSelectType.None,
    size,
    color,
    variant,
    captionText,
    captionPosition,
  };
}
